import React from 'react';

/**
 * Avatar do usuário: mostra a foto de perfil (user.foto_url) quando existir,
 * senão um círculo com a inicial do nome. Reutilizável em sidebar/topbar/mobile.
 *
 * Props:
 *  - user: objeto do usuário ({ name, foto_url })
 *  - size: diâmetro em px (default 32)
 *  - className: classes extras no wrapper
 *  - fallbackClassName: cor do círculo quando não há foto (default navy da marca)
 *  - onClick: torna o avatar clicável (cursor-pointer)
 *  - title: tooltip (default = nome do usuário)
 */
const UserAvatar = ({
  user,
  size = 32,
  className = '',
  fallbackClassName = 'bg-primary text-white',
  onClick,
  title,
}) => {
  const initial = user?.name?.charAt(0)?.toUpperCase() || 'U';
  const dim = { width: size, height: size };
  const base = `rounded-full flex items-center justify-center overflow-hidden flex-shrink-0 ${onClick ? 'cursor-pointer' : ''} ${className}`;

  if (user?.foto_url) {
    return (
      <img
        src={user.foto_url}
        alt={user?.name || 'Usuário'}
        title={title || user?.name}
        onClick={onClick}
        style={dim}
        className={`object-cover ${base}`}
      />
    );
  }

  return (
    <div
      onClick={onClick}
      title={title || user?.name}
      style={dim}
      className={`font-semibold ${fallbackClassName} ${base}`}
    >
      <span style={{ fontSize: Math.max(10, Math.round(size * 0.42)) }}>{initial}</span>
    </div>
  );
};

export default UserAvatar;
